import { ca } from '@cian/analytics';

import { EEstimationPeriods } from 'shared/repositories/price-estimator/entities/estimation_trend/OfferCardEstimationV3ResponseSchema';

export function trackEstimateClick() {
  ca('eventSite', {
    action: 'bti_click',
    category: 'card',
    label: 'estimate_button',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackCostEstimateVisible() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'Scroll',
    label: 'estimate_block',
    useLastProducts: true,
  });
}

export function trackChartTooltipShow() {
  ca('eventSite', {
    action: 'bti_click',
    category: 'card',
    label: 'graph_tooltip',
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** Ховер/Тап на i рядом с Оценка Циан */
export function trackOfferValuationAboutOpen() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'show_sopr_about_estimation',
    label: 'estimation',
    useLastProducts: true,
  });
}

/** Ховер/Тап на лейбл Хорошая цена */
export function trackOfferValuationGoodPriceOpen() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'show_good_price',
    label: 'estimation',
    useLastProducts: true,
  });
}

const mapEstimationPeriodToLabel: Record<EEstimationPeriods, string> = {
  [EEstimationPeriods.EstimatePeriodWeek]: 'week',
  [EEstimationPeriods.EstimatePeriodMonth]: 'month',
  [EEstimationPeriods.EstimatePeriodHalfYear]: 'halfYear',
};

/** Клики на фильтры Неделя/месяц/полгода */
export function trackOfferValuationPeriodFilterClick(period: EEstimationPeriods) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'estimation_period',
    label: mapEstimationPeriodToLabel[period],
    useLastProducts: true,
  });
}

/** Teaser. Доступность блока оценки */
export function trackEstimationBlockExist() {
  ca('teaser', {
    product: {
      name: 'estimation_block_exist',
    },
  });
}
